import React, { useContext } from 'react';

    
import { AssetsContext } from '../../context';

import { AssetList } from './asset-list';
import { ModalFormHeader } from './modal-form-header';
import { NoAssetsDisplay } from './no-assets-display';

interface WillAssetSummaryProps {
  handleRemoveAsset: (id: string) => void;
  handleEditAsset: (id: string) => void;
}

export function WillAssetSummary({
  handleRemoveAsset,
  handleEditAsset
}: WillAssetSummaryProps) {
  const { assets } = useContext(AssetsContext);
  
  return (
    <div className="form-container">
      <ModalFormHeader
        icon="savings"
        header="Assets"
      />
      { assets.length > 0 ? (
        <AssetList 
          assets={assets} 
          handleRemove={handleRemoveAsset} 
          handleEdit={handleEditAsset} 
        />
      ) : (
        <NoAssetsDisplay 
          compact
          icon="info" 
          title="No Assets" 
          description="Add your property, accounts, and belongings." />
      )}
    </div>
  );
}